import React from 'react'

const Instagram = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
    <svg
        width="26"
        height="25"
        viewBox="0 0 26 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <path
            d="M25.1571 10.4005C24.1919 1.74366 13.3056 -2.94186 5.85213 2.02939C2.81856 4.0507 0.786456 7.40058 0.184089 10.9576C-0.229586 13.4147 0.0389374 16.0361 1.14207 18.3002C2.24523 20.5573 4.08857 22.393 6.48361 23.2643C13.9225 25.9858 24.0321 23.05 25.1571 14.479C25.3385 13.129 25.3095 11.7504 25.1571 10.4005Z"
            fill="#666059"
        />
        <path
            d="M18.8424 16.8991C18.7697 17.2348 18.6681 17.599 18.3778 17.8062C18.1528 17.9632 17.8626 18.0062 17.5869 18.0277C14.9089 18.2918 11.2949 18.2489 8.60968 18.1275C7.80423 18.0919 6.8462 17.9632 6.49059 17.2706C6.37452 17.0491 6.3455 16.7991 6.31647 16.5563C5.98261 13.785 6.22214 7.54272 6.42538 7.15695C6.82446 6.38562 7.87672 6.19996 8.78392 6.12851C10.5256 5.97852 12.8407 6.0714 15.1049 6.0714C16.941 6.0714 18.0222 6.00712 18.3997 6.43565C19.3793 7.57122 19.1037 15.7135 18.8424 16.8991Z"
            fill="white"
            stroke="white"
            strokeWidth="0.808216"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.4127 10.1156C11.2081 10.2369 10.105 10.9441 9.96701 12.2083C9.85823 13.2082 10.446 14.2152 11.3895 14.6081C12.1877 14.9438 13.407 15.0081 14.1835 14.5938C15.0543 14.1224 15.4462 13.1868 15.2938 12.2655C15.1196 11.2227 14.4375 10.3513 13.3272 10.1442C13.0442 10.0869 12.732 10.0799 12.4127 10.1156Z"
            fill="#666059"
            stroke="#666059"
            strokeWidth="0.808216"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.3819 8.95303C16.3964 8.88156 16.3964 8.80298 16.3891 8.72448C16.2947 7.98135 15.1041 8.13138 15.0387 8.81018C15.0171 9.08885 15.213 9.36745 15.4889 9.44604C15.9318 9.57458 16.3166 9.34603 16.3819 8.95303Z"
            fill="#666059"
            stroke="#666059"
            strokeWidth="0.808216"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default Instagram
